import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import { FormattedMessage } from 'ui/i18n';
import { CUSTOMER_PHONE_NUMBER, COUNTRIES } from 'config/constants';

import { PageHeader } from 'ui/components';

import './Help.scss';

@inject('AppState')
export default class HelpPage extends Component {
	static propTypes = {
		AppState: PropTypes.object.isRequired,
	};

	render() {
		const countryName = this.props.AppState.user
			? this.props.AppState.user.country.long_name
			: COUNTRIES.US;

		const customerPhone = CUSTOMER_PHONE_NUMBER[countryName];
		return (
			<div className="HelpPage">
				<div>
					<div>
						<PageHeader
							id="Help-page-header"
							headerText={
								<span>
									<FormattedMessage id="navigation.help" />
								</span>
							}
						/>

						<div className="HelpPage-content">
							<h3>SOLO Help</h3>

							<p>
								To contact <strong>Customer Care Center</strong> call{' '}
								{customerPhone}.
							</p>

							<h3>Aide de SOLO</h3>

							<p>
								Pour communiquer avec le centre de service à la clientèle par
								telephone appel: 1-877-762-7662.
							</p>

							{/* <h3>SOLO Administrators</h3>
							<ul>
								<li>
									<ExternalLink
										href="https://www1.snapon.com/Files/SOLO/SOLOAdmin.pdf"
										text="Admin manual"
										openInNewTab={true}
									/>
								</li>
							</ul> */}
						</div>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/pages/Help/index.js